export default __webpack_public_path__ + "static/media/infografia_ post_adopcion.8a683f89.pdf";